import { render, staticRenderFns } from "./software.vue?vue&type=template&id=0ba34356&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"
import style0 from "./software.vue?vue&type=style&index=0&id=0ba34356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba34356",
  null
  
)

export default component.exports